goog.provide("shadow.js.shim.module$dayjs$plugin$utc");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$utc");
shadow.js.shim.module$dayjs$plugin$utc = shadow.js.nativeProvides["dayjs/plugin/utc"] = require("dayjs/plugin/utc");
module$shadow_js_shim_module$dayjs$plugin$utc.default = shadow.js.shim.module$dayjs$plugin$utc;
